export const appColors = {
    green: "#64E300",
    bgMuted: "#F2F2F2",
    bgDefault: "#FCFCFC",
    uiSecondary: "#F2F2F7",
    uiSecondaryDisabled: "#C9C9D1",
    textSecondary: "#393939",
    primary: "#E34D5C",
    textPrimary: "#0E0E0E",
} as const;

